import memCache from './memCache';
export default {
  get(key) {
    if (!window.localStorage) {
      return memCache.get(key);
    }
    return window.localStorage.getItem(key);
  },
  set(key, value) {
    if (!window.localStorage) {
      return memCache.set(key);
    }
    return window.localStorage.setItem(key, value);
  },
  remove(key) {
    if (!window.localStorage) {
      return memCache.remove(key);
    }
    return localStorage.removeItem(key);
  },
};
